export default __webpack_public_path__ + "static/media/discover.9b4fc6aa.svg";